export function setOrganizationUsers(state, users) {
  state.organizationUsers = users;
}